import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { EstimateProvider } from "@/components/site/EstimateDialog";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee, TrustBar } from "@/components/site/Marquee";
import { Services } from "@/components/site/Services";
import { WhyChooseUs, HowItWorks } from "@/components/site/WhyChooseUs";
import { Residential, Commercial } from "@/components/site/Segments";
import { Gallery } from "@/components/site/Gallery";
import { ServiceArea } from "@/components/site/ServiceArea";
import { Reviews } from "@/components/site/Reviews";
import { About } from "@/components/site/About";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);

    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id.length > 1) {
        const el = document.querySelector(id);
        if (el) { e.preventDefault(); lenis.scrollTo(el, { offset: -80 }); }
      }
    };
    document.addEventListener("click", onClick);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); document.removeEventListener("click", onClick); };
  }, []);

  return (
    <EstimateProvider>
      <div className="App min-h-screen bg-white">
        <Nav />
        <main>
          <Hero />
          <Marquee />
          <TrustBar />
          <Services />
          <WhyChooseUs />
          <Residential />
          <Commercial />
          <HowItWorks />
          <Gallery />
          <ServiceArea />
          <Reviews />
          <About />
          <Contact />
        </main>
        <Footer />
      </div>
      <Toaster position="top-center" richColors />
    </EstimateProvider>
  );
}

export default App;
